import { Routes } from '@angular/router';
import { devGuardFn } from '@auth';
import { hasPermissionGuardFn } from '../auth/services/auth-permissions.service';
import { authGuardFn } from '@auth0/auth0-angular';

const DevRoutes: Routes = [
  {
    path: 'dev',
    loadComponent: () =>
      import('./pages/dev/dev.page').then((m) => m.DeveloperPage),
    canActivate: [devGuardFn],
  },
];

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/home',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('../auth/pages/login/login.page').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'callback',
    pathMatch: 'full',
    redirectTo: '/welcome',
  },
  {
    path: 'home',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'welcome',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/welcome/welcome.page').then((m) => m.WelcomePage),
    data: { showMenu: false },
  },
  {
    path: 'distribution-network',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/distribution-network/distribution-network.page').then(
        (m) => m.DistributionNetworkPage,
      ),
  },
  {
    path: 'administration',
    canActivate: [
      authGuardFn,
      hasPermissionGuardFn([
        'sabt:alarm_cfg:r',
        'sabt:alarm_cfg:admin',
        'sabt:alarm_cfg:w',
      ]),
    ],
    loadComponent: () =>
      import('./pages/administration/administration.page').then(
        (m) => m.AdministrationPage,
      ),
  },
  {
    path: 'losses',
    canActivate: [authGuardFn, hasPermissionGuardFn(['sabt:loss:r'])],
    loadComponent: () =>
      import('./pages/losses/losses.page').then((m) => m.LossesPage),
  },
  {
    path: 'events',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/events/events.page').then((m) => m.EventsPage),
  },
  {
    path: 'events/:centerId',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/events/events.page').then((m) => m.EventsPage),
  },
  {
    path: 'alarms/:centerId',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/alarms/alarms.page').then((m) => m.AlarmsPage),
  },
  {
    path: 'alarms',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/alarms/alarms.page').then((m) => m.AlarmsPage),
  },
  {
    path: 'distributors/:distributorId/center/:centerId/rsabts/:rsabtId',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/rsabt/rsabt.page').then((m) => m.CenterRsabtPage),
  },
  {
    path: 'distributors/:distributorId/center/:centerId/rsabts/:rsabtId/tsabts/:tsabtId',
    canActivate: [authGuardFn],
    loadComponent: () =>
      import('./pages/tsabt/tsabt.page').then((m) => m.CenterTsabtPage),
  },
  ...DevRoutes,
];
